import { ActivatedRoute } from '@angular/router';
import { AUSnackBarService } from '@app/notifications/au-snackbar.service';
import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LegacyService } from '@app/legacy/legacy.service';
import { RoutingStrategyService } from '@app/shared/services/routing-strategy.service';
import { SecurityService } from '@app/security/shared/security.service';
import { finalize } from 'rxjs/operators';

export const DB_SWITCH_QPARAM_TOKEN = 'token';
export const DB_SWITCH_QPARAM_DB = 'db';
export const DB_SWITCH_QPARAM_USERNAME = 'username';

@Component({
  standalone: true,
  selector: 'acs-database-switch',
  templateUrl: './database-switch.component.html',
  imports: [FontAwesomeModule],
  styles: [
    `
      :host {
        display: flex;
        flex: 1 1 auto;
      }
      .db-switcher-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        flex-direction: column;
      }
    `
  ]
})
export class DatabaseSwitchComponent {
  public database = '';
  public processing = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private auSnackBar: AUSnackBarService,
    private legacyService: LegacyService,
    private routingStrategyService: RoutingStrategyService,
    private securityService: SecurityService
  ) {
    this.makeAuthRequest();
    this.legacyService.skipLegacyIntercom();
  }

  private makeAuthRequest(): void {
    const qParams = this.activatedRoute.snapshot.queryParams;
    const token = qParams[DB_SWITCH_QPARAM_TOKEN];
    const username = qParams[DB_SWITCH_QPARAM_USERNAME];
    this.database = qParams[DB_SWITCH_QPARAM_DB];

    if (!Boolean(token) || !Boolean(this.database)) {
      this.auSnackBar.openError('Error processing route parameters - cannot logon right now');
      return;
    }

    this.securityService
      .loginWithTokenCredentials(token, username, this.database)
      .pipe(
        finalize(() => {
          this.processing = false;
        })
      )
      .subscribe({
        next: () => {
          console.log('and away we goo!');
          this.routingStrategyService.setTitle(`Database Switch - ${this.database}`);
          //this.router.navigate(['/home']);
        },
        error: (error) => {
          this.auSnackBar.openError(error);
        }
      });
  }
}
